var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 60,
    viewBox: "0 0 75 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.625 26.25C23.7316 26.25 26.25 23.7316 26.25 20.625C26.25 17.5184 23.7316 15 20.625 15C17.5184 15 15 17.5184 15 20.625C15 23.7316 17.5184 26.25 20.625 26.25Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.875 37.5L26.25 30L15 45H60L43.125 22.5L31.875 37.5Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5 0H7.5C3.36375 0 0 3.36375 0 7.5V52.5C0 56.6362 3.36375 60 7.5 60H67.5C71.6363 60 75 56.6362 75 52.5V7.5C75 3.36375 71.6363 0 67.5 0ZM7.5 52.5V7.5H67.5L67.5075 52.5H7.5Z",
    fill: "#363636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePostIcon);
export default __webpack_public_path__ + "static/media/image-post-icon.2f43251e05bf516ceadf28f7947b255a.svg";
export { ForwardRef as ReactComponent };